export default __webpack_public_path__ + "static/media/video.1d855cfb.svg";